import { FormattedMessage } from 'react-intl';
import Typography from '@alltrails/core/components/Typography';
import Sign from '@alltrails/denali/illustrations/Sign';
import styles from './errors.module.scss';

// Visual content shared between ErrorContent (mounted inside a fully bootstrapped app) and GlobalErrorPage (rendered when the root layout itself has failed, so no redux store is available).
// Keep this component free of any dependency that requires an app-level Provider — only intl is assumed, and FormattedMessage falls back to its inline defaultMessage when no catalog is present.
export default function ErrorContentBody() {
  return (
    <>
      <Sign />
      <div className={styles.error}>
        <Typography color="secondary" component="div" variant="heading500">
          <FormattedMessage defaultMessage="500" />
        </Typography>
      </div>
      <div className={styles.header}>
        <Typography component="div" variant="heading600">
          <FormattedMessage defaultMessage="Looks like we went off the trail" />
        </Typography>
      </div>
      <div className={styles.textContainer}>
        <div className={styles.text}>
          <Typography component="div" variant="paragraph300">
            <FormattedMessage defaultMessage="There seems to be a problem with our server. We're working hard to resolve the issue and should be back to normal soon." />
          </Typography>
        </div>
      </div>
    </>
  );
}
